// extracted by mini-css-extract-plugin
module.exports = {"heading":"style__heading__l+n05"};